import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon3D from '../Icons3D';
import { PROFILES, ROUTES, flatNav, isScreenActive } from '../../config/navigation';
import { setSidebarOpen } from '../../state/uiSlice';

/** Mobile bottom tab bar — first four destinations for the role, then More. */
export default function TabBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { role } = useSelector((s) => s.ui);
  const items = flatNav(PROFILES[role]).slice(0, 4);

  return (
    <nav className="tabbar">
      {items.map(([screen, icon, label]) => {
        const to = ROUTES[screen];
        const on = isScreenActive(screen, pathname);
        return (
          <button key={label} type="button" className={on ? 'on' : ''} onClick={() => navigate(to)}>
            <span className="tic tic3"><Icon3D name={icon} size={22} /></span>
            {label.replace(/ .*/, '')}
          </button>
        );
      })}
      <button type="button" onClick={() => dispatch(setSidebarOpen(true))}>
        <span className="tic">☰</span>
        More
      </button>
    </nav>
  );
}
